// extracted by mini-css-extract-plugin
module.exports = {"fixed":"Dialog_fixed__YpIZT","draggable":"Dialog_draggable__Y6vz-","rnd":"Dialog_rnd__1WtwL","dialog":"Dialog_dialog__2VJUo","backdrop":"Dialog_backdrop__1IN9y"};